var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-autocomplete',{staticClass:"introInput",attrs:{"options":{
      bounds: _vm.state.OXFORD_BOUNDS,
      strictBounds: true, 
      fields: ['geometry', 'formatted_address']
  }},on:{"place_changed":_vm.addMarker}})}
var staticRenderFns = []

export { render, staticRenderFns }